<template>
    <div>
        <v-container grid-list-lg  fluid>
            <div class="category-wrapper">
                <div v-if="$route.params.id!=null">
                    <span v-for="(projects, i) in getCaseStudy" :key="i">
                        <router-link :to="{ name: 'CaseStudyProject', params:{category:$route.params.id, slug:projects.slug}}">
                            <span class="projects">
                                <img :src="projects.featuredImage" class=""><br>
                                {{projects.projectName}}
                            </span>
                        </router-link>  
                    </span> 
                </div> 
                
                <div v-else>
                    <span v-for="(projects, i) in getCaseStudiesCategories" :key="i">

                        <span v-for="(project, cat) in projects" :key="cat">
                            <router-link :to="{ name: 'CaseStudyProject', params:{category:i, slug:project.slug}}">
                               
                                <span class="projects">
                                    <img :src="project.featuredImage" class=""><br>
                                    {{project.projectName}}
                                </span>
                            </router-link>  
                        </span>
                       
                    </span> 
                </div>
            </div>
        </v-container>       
    </div>
</template>

<script>
export default {
    name:'CaseStudyCategory',
    computed:{
        getCaseStudiesCategories(){
            return this.$store.getters.getCaseStudiesAll;
        },

        getCaseStudy(){
            return this.$store.getters.getCaseStudiesByCategory(this.$route.params.id);
        }
    }

}
</script>

<style scoped>
.projects{
    display:inline-block;
    margin:20px;
    width:250px;
    height:180px;
    color:#505050;
    font-size:16px;
}

.projects img{
    width:100%;
}

.category-wrapper{
    text-align:center;
}
</style>
